// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface VaultExtendedInfoUpdateOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface VaultExtendedInfoCreateOrUpdateOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface VaultExtendedInfoGetOptionalParams extends OperationOptions {}
